export const MarketingEvent = {
  MarketingLandingView: 'marketing_landing_view',
  MarketingLandingTopClick: 'marketing_landing_top_click',
  MarketingLandingBottomClick: 'marketing_landing_bottom_click',
  MarketingLandingScrolled: 'marketing_landing_scrolled',
} as const;

interface MarketingParameters {
  button_url: string;
  button_text: string;
}

export interface MarketingDataType {
  [MarketingEvent.MarketingLandingTopClick]: MarketingParameters;
  [MarketingEvent.MarketingLandingBottomClick]: MarketingParameters;
  [MarketingEvent.MarketingLandingScrolled]: {
    scroll_direction: 'vertical';
    path: string; // url path after '/marketing/'
    section_type: string;
    section_index: string;
  };
}

export const marketingEventEvent = {
  pageView: 'marketing_event_landing_view',
  buttonClick: 'marketing_event_landing_button_click',
  scrolled: 'marketing_event_landing_scrolled',
  faqOpen: 'marketing_event_landing_faq_open',
} as const;

export interface MarketingEventDataType {
  [marketingEventEvent.scrolled]: {
    scroll_direction: 'vertical';
    event_path: string;
    section_type: string;
    section_index: number;
  };
  [marketingEventEvent.buttonClick]: {
    section_type: string;
    section_index: number;
    button_text: string;
    button_url: string;
  };
  [marketingEventEvent.faqOpen]: {
    faq_title: string;
    list_order: number;
  };
}
